import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import MusicItem from '../components/MusicItemComponent';
import { setPlaylist } from '../../../common/Playlist/actions/PlaylistActions';
import { pauseMediaPlayer, playMediaPlayer } from '../../aovivoBar/actions/MediaPlayerActions';

const mapStateToProps = (state) => ({
    // MediaPlayer
    playerStatus: state.aovivoBar.MediaPlayer.playerStatus,
    // Playlist
    currentIndex: state.playlist.currentIndex,
    currentMusicId: state.playlist.currentMusicId,
    filteredMusics: state.musics.musicsPage.filteredMusics,
    isLive: state.aovivoBar.MediaPlayer.isLive,
});
const mapDispatchToProps = (dispatch) => ({
    setPlaylist: (playlistType, trackList, currentIndex, currentMusicId) => dispatch(
        setPlaylist(playlistType, trackList, currentIndex, currentMusicId),
    ),

    pauseMediaPlayer: () => dispatch(pauseMediaPlayer()),

    playMediaPlayer: () => dispatch(playMediaPlayer()),
});
const MusicItemContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(MusicItem);

export default withRouter(MusicItemContainer);
